"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _CookieAgreementsProvider = require("@deosite/api/hooks/common/CookieAgreementsProvider");
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _useDebounce = _interopRequireDefault(require("@deosite/lib/useDebounce"));
var _setAgreementsCookie = _interopRequireDefault(require("@deosite/helpers/setAgreementsCookie"));
var _router = require("next/router");
var _useLoader2 = require("@deosite/api/hooks/common/useLoader");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var CookieContainer = function CookieContainer(_ref) {
  var cookieNotice = _ref.cookieNotice,
    cookiesPanel = _ref.cookiesPanel;
  var _useState = (0, _react.useState)(false),
    showPanel = _useState[0],
    setShowPanel = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    showImportComponent = _useState2[0],
    setShowImportComponent = _useState2[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var router = (0, _router.useRouter)();
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements,
    setCookieAgreements = _useCookieAgreements.setCookieAgreements,
    analyticsID = _useCookieAgreements.analyticsID,
    gtmID = _useCookieAgreements.gtmID,
    fbID = _useCookieAgreements.fbID;
  var _useLoader = (0, _useLoader2.useLoader)(),
    setCookieNoticeLoaded = _useLoader.setCookieNoticeLoaded;
  var _useState3 = (0, _react.useState)(-1),
    displayedElement = _useState3[0],
    setDisplayedElement = _useState3[1];
  (0, _react.useEffect)(function () {
    setDisplayedElement(cookieAgreements ? -1 : 1);
  }, [cookieAgreements]);
  var domain = language.domain.split(".");
  var domainForTranslation = "".concat(domain[0].toUpperCase(), ".").concat(domain[1]);
  var cookieInfo = /*#__PURE__*/_react["default"].cloneElement(cookieNotice, {
    onAcceptButtonClick: function onAcceptButtonClick() {
      return setAllAgreementsTrue();
    },
    onManageOptionsButtonClick: function onManageOptionsButtonClick() {
      setShowPanel(true);
    },
    domain: domainForTranslation
  });
  var setAllAgreementsTrue = function setAllAgreementsTrue() {
    (0, _setAgreementsCookie["default"])({
      agreements: true,
      language: language,
      cookieAgreements: {
        setCookieAgreements: setCookieAgreements,
        analyticsID: analyticsID,
        gtmID: gtmID,
        fbID: fbID
      }
    });
  };
  var importComponentsDebounce = (0, _useDebounce["default"])(parseInt(global.__appConfig__.cookieContainerLoadTimeout), function () {
    setShowImportComponent(true);
    setCookieNoticeLoaded(true);
  });
  var importComponent = function importComponent(show) {
    var CookiesPanel = cookiesPanel;
    return __jsx(_react["default"].Fragment, null, __jsx(CookiesPanel, {
      showPanel: show,
      setShowPanel: setShowPanel,
      domain: domainForTranslation
    }));
  };
  var panel = __jsx(_react["default"].Fragment, null, typeof window !== "undefined" && !cookieAgreements && !showPanel && __jsx(_Container["default"], {
    sx: {
      pb: 20
    }
  }, cookieInfo), showImportComponent ? importComponent(showPanel) : importComponentsDebounce());
  var noBackground = __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      bottom: 0,
      zIndex: 999
    }
  }, panel);
  var background = __jsx(_Box["default"], {
    sx: {
      position: "fixed",
      bg: "rgba(0, 0, 0, 0.3)",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: !cookieAgreements && displayedElement === 1 ? "flex" : "none",
      alignItems: "flex-end",
      zIndex: 999
    }
  }, panel);
  return __jsx(_Box["default"], null, !cookieAgreements && router.pathname === "/info/[info]" ? noBackground : background);
};
var _default = CookieContainer;
exports["default"] = _default;